import React, { useState, useEffect } from "react";
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';
import Select from "react-select";
import { Line } from "react-chartjs-2";

import { useDispatch, } from "react-redux";
import { SetComponentId } from "../../redux/counterSlice";
import API from "../../services/api";

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
  );
function SalesTrajectory(props) {
  const { salesPerson_id, year,setScrollTo } = props;
  const dispatch = useDispatch();
  dispatch(SetComponentId(50));
  const [loader, setLoader] = useState(false);
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [brands, setBrands] = useState([]);
  const [brandWise, setBrandWise] = useState();
  const [overall, setOverall] = useState();


  const fetchOverall = async () => {
    try {
      let res = await API({
        url: "/trajectory/overall",
        method: "POST",
        responseType: "json",
        data: {
            sales_id:salesPerson_id,
            year
        },
      });
      if (res.code === 200) {
        setOverall(res.data);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const handleSelectedBrand = (selectedBrand) => {
    setSelectedBrand(selectedBrand);
    setScrollTo(selectedBrand?.label);
  };

  const fetchBrandWise = async () => {
    try {
      let res = await API({
        url: "/trajectory/brandwise",
        method: "POST",
        responseType: "json",
        data: {
            sales_id:salesPerson_id,
            year,
            brand_id:selectedBrand?.value
        },
      });
      if (res.code === 200) {
        setBrandWise(res.data);
      }
      else{
        setBrandWise({sales:[], targets:[]})      }
    } catch (error) {
      console.error(error);
    }
  };
  const fetchBrands = async () => {
    try {
      let res = await API({
        url: "/trajectory/brands",
        method: "POST",
        responseType: "json",
        data: {
            sales_id:salesPerson_id,
        },
      });
      if (res.code === 200) {
        setBrands(res.data);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const chartData = {
    labels: [
      'January', 'February', 'March', 'April', 'May', 
      'June', 'July', 'August', 'September', 'October', 
      'November', 'December'
    ],
    datasets: [
      {
        label: 'Sales',
        data: overall?.sales,
        borderColor: 'blue',
        fill: false
      },
      {
        label: 'Target',
        data: overall?.targets,
        borderColor: 'green',
        fill: false
      }
    ]
  };
  const brandChartData = {
    labels: [
      'January', 'February', 'March', 'April', 'May', 
      'June', 'July', 'August', 'September', 'October', 
      'November', 'December'
    ],
    datasets: [
      {
        label: 'Sales',
        data: brandWise?.sales,
        borderColor: 'blue',
        fill: false
      },
      {
        label: 'Target',
        data: brandWise?.targets,
        borderColor: 'green',
        fill: false
      }
    ]
  };
  const options = {
    responsive: true,
    plugins: {
      title: {
        display: true,
        text: 'Sales vs Target'
      },
      tooltip: {
        mode: 'index',
        intersect: false
      }
    },
    scales: {
      x: {
        title: {
          display: true,
          text: 'Month'
        }
      },
      y: {
        title: {
          display: true,
          text: 'Amount'
        }
      }
    }
  };
  useEffect(() => {
    fetchOverall();
  }, [year, salesPerson_id]);

  useEffect(() => {
    if (selectedBrand != null) fetchBrandWise();
  }, [selectedBrand, salesPerson_id]);

  useEffect(() => {
    fetchBrands();
  }, [salesPerson_id]);

  return (
    <>

      <div className="d-flex flex-wrap mt-2">
        <div className="md:w-1/2">
          <h5>Target Vs Achieved</h5>
          <Line data={chartData} options={options} className="!h-64" />
        </div>
        <div className="md:w-1/2">
          <h5>Brand Target vs Brand Achieved</h5>
          <div>
            <label className="form-label">Choose Brand</label>
            <br></br>
            <Select
              options={brands}
              onChange={(selected) => handleSelectedBrand(selected)}
            ></Select>
          </div>
          <Line data={brandChartData} options={options} className="!h-64 " />
        </div>
      </div>
    </>
  );
}

export default SalesTrajectory;
